import { LandingTemplate } from "@/components/LandingTemplate";
import { IMG, FAQS } from "@/data/site";

const poolFaqs = FAQS.filter((f) => f.c === "Pool");

export default function IndoorPool() {
  return (
    <LandingTemplate
      seo={{
        title: "Indoor Pool Hotel in Ottawa, KS",
        description: "Super 8 Ottawa features a heated indoor swimming pool open year-round — the family hotel with a pool near I-35 in Ottawa, Kansas. Great for winter travel, weekend getaways and rainy days.",
        path: "/indoor-pool",
        breadcrumbs: [{ name: "Home", path: "/" }, { name: "Indoor Pool", path: "/indoor-pool" }],
        faqs: poolFaqs,
      }}
      kicker="Amenity Spotlight"
      heroTitle="Indoor Heated Pool"
      heroLines={["Dive in", "any day", "of the year"]}
      heroImage={IMG.pool}
      intro="Our heated indoor swimming pool is one of the best reasons to book direct. Swim laps, splash with the kids, or simply unwind — no matter the Kansas weather outside. It's the year-round amenity that turns an overnight stop into a genuine getaway."
      audiences={["Families", "Winter travelers", "Weekend getaways", "Rainy-day travel", "Kids' activities", "Swimmers"]}
      features={[
        { icon: "Waves", title: "Heated & Indoor", desc: "Comfortable water temperature all year, protected from wind, rain and snow." },
        { icon: "Thermometer", title: "Comfortable Temperature", desc: "Kept at a pleasant temperature so the water's inviting every day." },
        { icon: "Users", title: "Family Favorite", desc: "The perfect way to keep kids happy after a long day on the road." },
        { icon: "Clock", title: "Open Daily", desc: "Posted daily hours — swim in the morning or wind down at night." },
        { icon: "Sun", title: "Year-Round Fun", desc: "Summer heat or winter chill, the pool is always ready." },
        { icon: "ShowerHead", title: "Easy Access", desc: "Steps from your room, with towels and a relaxed poolside area." },
      ]}
      bandImage={IMG.poolKids}
      bandTitle="Why an indoor pool matters"
      bandText="An indoor pool transforms your trip from a place to sleep into a place to unwind. Families get a built-in activity, business travelers get a way to decompress, and everyone gets a reason to look forward to the stay — whatever the forecast."
      benefits={[
        "Heated water for year-round swimming",
        "Perfect for families and rainy-day travel",
        "A relaxing end to a long drive on I-35",
        "Free for all registered guests",
      ]}
      keywords={["Hotel with indoor pool Ottawa KS", "Indoor pool hotel near me", "Family hotel with pool", "Swimming pool hotel Ottawa Kansas", "Hotel with indoor swimming pool I-35"]}
      faqs={poolFaqs}
    />
  );
}
